<template>
  <div class="footer">
    <a-row>
      <a-col :span="12">
        <div class="copyright">
          <a-icon type="copyright" color="#C4C5C6" size="18"/>
          <span class="copyright-span" v-html="copyright + `&emsp;&emsp;` + ICP"></span>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="privacy">
          <!-- <span>隐私政策声明</span> -->
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: ['copyright', 'ICP'],
  beforeCreate () {
    let fontSize = 20 * document.body.clientWidth / 1920
    if (fontSize < 14.25) {
      document.getElementsByTagName('html')[0].style.fontSize = '14.25px'
    } else {
      document.getElementsByTagName('html')[0].style.fontSize = fontSize + 'px'
    }
  },
  mounted () {
    window.onresize = () => {
      this.$nextTick(() => {
        let fontSize = 20 * document.body.clientWidth / 1920
        if (fontSize < 14.25) {
          document.getElementsByTagName('html')[0].style.fontSize = '14.25px'
        } else {
          document.getElementsByTagName('html')[0].style.fontSize = fontSize + 'px'
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .footer {
    width: 100%;
    height: 5rem;
    font-size: 1rem;
    background-color: #333;
    .ant-row {
      height: 5rem;
      padding: 0 2.25rem;
      line-height: 5rem;
      font-size: .9rem;
      .copyright {
        height: 5rem;
        line-height: 5rem;
        color: #C4C5C6;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .privacy {
        color: #C4C5C6;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span {
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?400c85ac